// @flow
import React from 'react';
import { connect } from 'react-redux';
import CarIcon from '@material-ui/icons/DirectionsCar';
import type { State } from '../../../types';
import appActions from '../../../actions/appActions';
import { activeCarListSelector } from '../../../selectors/carSelectors';
import type { Props } from '../Navbar';

type OwnProps = $ReadOnly<{
    now: Date
}>;

const mapStateToProps = (state: State, props: OwnProps) => {
    return {
        carCount: activeCarListSelector(state, { now: props.now }).length
    };
};

const mapDispatchToProps = {
    setActiveSection: appActions.setSection
};


const CarIconComponent = ({ carCount, iconClass }) => (
    <span>
        <CarIcon className={iconClass} /> {carCount}
    </span>
);

export default connect<Props, OwnProps, _, _, _, _>(mapStateToProps, mapDispatchToProps)(CarIconComponent);